<i18n>
{
  "cl": {
    "idNumber": "Rut",
    "email": "Email",
    "phono": "Teléfono",
    "messageFieldLength":"Debe tener al menos 3 caracteres",
    "emptyResult":"No se encontraron resultados",
    "serverError": "Ocurrió un error al comunicarse con el servidor"
  },
  "pe": {
    "idNumber": "DNI/CE",
    "email": "Email",
    "phono": "Teléfono",
    "messageFieldLength":"Debe tener al menos 3 caracteres",
    "emptyResult":"No se encontraron resultados",
    "serverError": "Ocurrió un error al comunicarse con el servidor"
  },
  "br": {
    "idNumber": "CPF",
    "email": "Email",
    "phono": "Telefone",
    "messageFieldLength":"Deve ter pelo menos 3 caracteres",
    "emptyResult":"Nenhum resultado encontrado",
    "serverError": "Ocorreu um erro durante a comunicação com o servidor"
  }
}
</i18n>
<template>
  <b-autocomplete
    id="findLeadsInput"
    v-model="searchString"
    size="is-normal"
    field="nameLastName"
    rounded
    :expanded="expanded"
    class="search-bar"
    icon="search"
    :data="leads"
    :placeholder="placeholder"
    :loading="isLoading"
    @select="option => $emit('select', option)">
    <template slot-scope="props">
      <div>
        <div class="result-list">
          {{ `${props.option.name} ${props.option.lastName}` }}
          <br>
          <small>
            {{ $t('idNumber') }}: {{ props.option.idNumber }},
            {{ $t('email') }}: <strong>{{ props.option.email }}</strong>,
            {{ $t('phono') }}: {{ props.option.phone }}
          </small>
        </div>
      </div>
    </template>
    <template #empty>{{ emptyMessage }}</template>
  </b-autocomplete>
</template>
<script>
import { getProspectBySearchParam } from '@/application/services/api-clients/prospects-leads';

export default {
  props: ['placeholder', 'expanded'],
  data() {
    return {
      selectedClient: null,
      emptyMessage: '',
      isLoading: false,
      searchString: '',
      leads: [],
      cancelFindLeads: null
    };
  },
  watch: {
    async searchString(newValue) {
      if (newValue.length < 3) {
        this.emptyMessage = this.$t('messageFieldLength');
        this.leads = [];
        return;
      }
      if (this.isLoading) {
        this.cancelFindLeads('cancelled');
      }
      this.isLoading = true;
      try {
        this.leads = await getProspectBySearchParam(newValue, cancelFunction => {
          this.cancelFindLeads = cancelFunction;
        });
        this.emptyMessage = this.$t('emptyResult');
        this.isLoading = false;
      } catch (error) {
        if (error.message === 'cancelled') {
          return;
        }
        this.isLoading = false;
        this.emptyMessage = this.$t('serverError');
      }
    }
  }
};
</script>
<style>
.search-bar input{
  box-shadow: none !important;
  background-color: #EFEFEF;
  width:100%;
}

@media  (max-width: 660px) {
  .search-bar input{
    width: max-content;
  }
}
</style>
